import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { MenuOutlined } from '@ant-design/icons';
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button, List, Image } from 'antd';
import styles from './index.module.scss'
import Utils from '@utils/utils';
import InputNumber from '../InputNumber';


const SortableListItemContext = createContext({});
const DragHandle = ({ disabled }) => {
    const { setActivatorNodeRef, listeners, attributes } = useContext(SortableListItemContext);
    return (
        <Button
            className={styles.sortableListItemDragHandle}
            disabled={disabled}
            type="text"
            size="small"
            icon={<MenuOutlined />}
            style={{ cursor: 'pointer' }}
            ref={setActivatorNodeRef}
            {...attributes}
            {...listeners}
        />
    );
};

const SortableListItem = props => {
    const { itemKey, style, ...rest } = props;
    const {
        attributes,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: itemKey });
    const listStyle = {
        ...style,
        transform: CSS.Translate.toString(transform),
        transition,
        ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
    };
    const memoizedValue = useMemo(
        () => ({ setActivatorNodeRef, listeners, attributes }),
        [setActivatorNodeRef, listeners, attributes],
    );
    return (
        <SortableListItemContext.Provider value={memoizedValue}>
            <List.Item {...rest} ref={setNodeRef} style={listStyle} />
        </SortableListItemContext.Provider>
    );
}

const DragAndSort = (props) => {
    const { data, setData } = props

    const onDragEnd = ({ active, over }) => {
        if (!active || !over) {
            return;
        }
        if (active.id !== over.id) {
            setData(prevState => {
                const activeIndex = prevState.findIndex(i => i.key === active.id);
                const overIndex = prevState.findIndex(i => i.key === over.id);
                return arrayMove(prevState, activeIndex, overIndex);
            })
        }
    }

    const handleNumberChange = (type, item, value) => {
        setData(prevState => {
            const newState = [...prevState];
            const index = newState.findIndex(i => i.key === item.key);

            switch (type) {
                case 'minus':
                    if (newState[index].num > 1) {
                        newState[index].num--;
                    }
                    break;
                case 'add':
                    if (newState[index].num < 30) {
                        newState[index].num++;
                    }
                    break;
                case 'change':
                    newState[index].num = value;
                    break;
                default:
                    break;
            }

            return newState;
        })
    }


    return (
        <DndContext
            modifiers={[restrictToVerticalAxis]}
            onDragEnd={onDragEnd}
            id="list-drag-sorting-handler"
        >
            <div className={`${styles.sortableList} _beauty_scrollbar`} >
                <SortableContext items={data.map(item => item.key)} strategy={verticalListSortingStrategy}>
                    {
                        data.map((item, index) => {
                            return (
                                <SortableListItem key={item.key} itemKey={item.key}>
                                    <div className={styles.sortableListItem}>
                                        序号{index + 1}
                                        <div className={styles.sortableListItemImage} >
                                            <Image width={48} src={Utils.getImgThumbnail(item.url)} />
                                        </div>
                                        <InputNumber
                                            currentNum={item.num}
                                            min={1} max={30}
                                            minusChange={() => handleNumberChange('minus', item)}
                                            addChange={() => handleNumberChange('add', item)}
                                            onChange={(value) => handleNumberChange('change', item, value)} />
                                        <DragHandle disabled={data.length === 1} />
                                    </div>
                                </SortableListItem>
                            )
                        })
                    }
                </SortableContext>
            </div>
        </DndContext>
    );
};
export default DragAndSort;